<template>
    <div>

        <li v-bind:class="{'active': this.$route.name === 'ClientMails'}">
            <router-link :to="{name:'ClientMails'}">
                <span class="icon">
                    <MailIcon/>
                </span>
                <span class="text" v-html="$ml.with('VueJS').get('myDelayedMails')"></span>
            </router-link>
        </li>
        <li v-bind:class="{'active': this.$route.name === 'ClientContacts'}">
            <router-link :to="{name:'ClientContacts'}">
                <span class="icon">
                    <ClientsIcon/>
                </span>
                <span class="text" v-html="$ml.with('VueJS').get('contactFaces')"></span>
            </router-link>
        </li>
        <li v-bind:class="{'active': this.$route.name === 'ClientProfile'}">
            <router-link :to="{name: 'ClientProfile'}">
                <span class="icon">
                    <ProfileIcon/>
                </span>
                <span class="text" v-html="$ml.with('VueJS').get('profile')"></span>
            </router-link>
        </li>
    </div>
</template>



<script>
    import MailIcon from "./icons/MailIcon";
    import ClientsIcon from "./icons/ClientsIcon";
    import ProfileIcon from "./icons/ProfileIcon";
    import PlusIcon from "@/components/icons/PlusIcon";


    export default {
        name: 'ClientNavigationItems',

        components: {PlusIcon, ProfileIcon, ClientsIcon, MailIcon}

    }
</script>